/**
 * /apps/:appId/setup
 *
 * Tabbed shell containing the five setup sections:
 *   Organisation · Locations · Branches · Departments · Roles
 *
 * Sub-routes render via <Outlet />. Hitting /setup with no tab redirects
 * to /setup/organisation.
 */

import React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';

const TABS = [
  { to: 'organisation',  label: 'Organisation'  },
  { to: 'locations',     label: 'Locations'     },
  { to: 'branches',      label: 'Branches'      },
  { to: 'departments',   label: 'Departments'   },
  { to: 'roles',         label: 'Roles'         },
  { to: 'services',      label: 'Services'      },
  { to: 'hr-policies',   label: 'HR Policies'   },
  { to: 'org-chart',     label: 'Org Chart'     },
  { to: 'settings',     label: 'Other Settings' },
];

export default function OrganisationSetup() {
  const { appId } = useParams();
  return (
    <div className="setup-page">
      <h1 className="page-title">Organisation</h1>
      <p className="page-subtitle">
        The structural definition of your organisation: identity, locations,
        branches, departments, and the roles people perform here.
      </p>

      <div className="setup-tabs" role="tablist">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={`/apps/${appId}/setup/${t.to}`}
            className={({ isActive }) =>
              `setup-tab ${isActive ? 'active' : ''}`
            }
            role="tab"
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <div className="setup-tab-body">
        <Outlet />
      </div>
    </div>
  );
}
